import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import NavBar from "@/components/NavBar";
import ProtectedRoute from "@/components/ProtectedRoute";
import CalculatorPage from "@/pages/CalculatorPage";
import LoginPage from "@/pages/LoginPage";
import BiayaPakanPage from "@/pages/BiayaPakanPage";
import DataSapiPage from "@/pages/DataSapiPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import HppPage from "@/pages/HppPage";

export default function App() {
  useEffect(() => {
    document.title = "Sembada Satwa — Kalkulator Pakan Sapi";
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF3E8]">
      <BrowserRouter>
        <AuthProvider>
          <ConfigProvider>
            <NavBar />
            <Routes>
            <Route path="/" element={<CalculatorPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/biaya"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <BiayaPakanPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/data-sapi"
              element={
                <ProtectedRoute allowedRoles={["admin", "pegawai"]}>
                  <DataSapiPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pengaturan"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hpp"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <HppPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          </ConfigProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}
